import { MarkdownContent, TextField } from "~components";
import type { TextAnswerType } from "~onboarding/utils";

type TextAnswerProps = Omit<TextAnswerType, "type"> & {
  /**
   * The value of the entered text.
   */
  value?: string;
  /**
   * When entering text, pass the `value` to the parent.
   */
  onChange: (value?: string) => void;
  /**
   * Optional markdown content to display before the text field.
   */
  markdownBefore?: string;
  /**
   * Disables the editability of the answer.
   */
  isReadOnly?: boolean;
};

export function TextAnswer(props: TextAnswerProps) {
  const { value, onChange, isReadOnly, label, placeholder, markdownBefore } = props;

  return (
    <div css={{ display: "flex", flexDirection: "column", gap: 16 }}>
      {markdownBefore && (
        <MarkdownContent
          data-testid="markdown-before"
          body={markdownBefore}
          css={{ width: "100%" }}
        />
      )}
      <TextField
        type="text"
        value={value}
        // An empty string is considered an unanswered question
        onChange={(value) => onChange(value === "" ? undefined : value)}
        isDisabled={isReadOnly}
        label={label}
        placeholder={placeholder}
      />
    </div>
  );
}
